import { useTranslation } from "react-i18next";
import { SearchX } from "lucide-react";
import { ProductState } from "../../components/common/ProductState/index.js";
import { Button } from "../../components/ui/button/index.js";
import type { ReportEmptyKind } from "./report-empty-kind.js";

export function ReportResultState({
  kind,
  i18nPrefix,
  onResetFilters,
  testId,
}: {
  kind: ReportEmptyKind;
  i18nPrefix: "reports.campaigns" | "reports.outgoing" | "reports.incoming" | "reports.messageLog" | "reports.contactImports";
  onResetFilters: () => void;
  testId: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const filtered = kind !== "empty";
  const titleKey =
    kind === "filtered"
      ? `${i18nPrefix}.noMatchingTitle`
      : kind === "dateRange"
        ? `${i18nPrefix}.dateRangeTitle`
        : `${i18nPrefix}.emptyTitle`;
  const bodyKey =
    kind === "filtered"
      ? `${i18nPrefix}.noMatching`
      : kind === "dateRange"
        ? `${i18nPrefix}.dateRange`
        : `${i18nPrefix}.empty`;

  return (
    <ProductState
      tone={filtered ? "filtered" : "empty"}
      testId={testId}
      visual={
        filtered ? (
          <span className="inline-grid size-9 place-items-center rounded-full bg-surface-muted text-ink-muted">
            <SearchX size={16} aria-hidden="true" />
          </span>
        ) : null
      }
      title={t(titleKey)}
      description={t(bodyKey)}
      action={
        filtered ? (
          <Button
            type="button"
            size="sm"
            variant="outline"
            onClick={onResetFilters}
            data-testid={`${testId}-reset`}
          >
            {t(`${i18nPrefix}.resetFilters`)}
          </Button>
        ) : null
      }
    />
  );
}
